import axios from '@axios'
import moment from 'moment'
import { storePagination } from '@/mixins/store'

const getInitialState = () => ({
  ...storePagination.state(),

  results: [],

  /** Totais do filtro inteiro, somados no banco — não são da página exibida. */
  summary: null,

  /** URL temporária (blob) da planilha gerada pelo servidor. */
  reportData: null,

  sorting: {
    sortBy: 'id',
    sortDesc: true,
  },

  filters: {
    // Nulo em qualquer filtro significa "todos".
    storeId: null,
    paymentChannel: null,
    installmentMode: null,
    installmentPolicyId: null,
    acquirer: null,
    cardBrand: null,
    onlyDivergent: false,
    rangeDate: {
      startDate: moment().add(-30, 'days').startOf('day').format(),
      endDate: moment().endOf('day').format(),
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_RESULTS(state, results) {
      state.results = results
    },

    SET_SUMMARY(state, summary) {
      state.summary = summary
    },

    SET_REPORT_DATA(state, reportData) {
      state.reportData = reportData
    },

    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_FILTERS(state) {
      state.filters = getInitialState().filters
    },

    CLEAN_STATE(state) {
      Object.assign(state, getInitialState())
    },
  },

  actions: {
    ...storePagination.actions,

    /**
     * Filtros da tela traduzidos em parâmetros da API.
     *
     * Compartilhado entre a grade e o download de propósito: a planilha tem de ser o mesmo recorte
     * que está na tela, e dois montadores de parâmetro divergiriam no primeiro filtro novo.
     */
    buildFilterParams({ state }) {
      const {
        storeId,
        paymentChannel,
        installmentMode,
        installmentPolicyId,
        acquirer,
        cardBrand,
        onlyDivergent,
        rangeDate,
      } = state.filters

      return {
        storeId,
        paymentChannel,
        installmentMode,
        installmentPolicyId,
        acquirer,
        cardBrand,
        onlyDivergent: onlyDivergent || undefined,
        dateFrom: rangeDate?.startDate,
        dateTo: rangeDate?.endDate,
      }
    },

    async fetchReport({ commit, state, dispatch }) {
      const { data } = await axios.get('/api/reports/installment-sales', {
        params: {
          ...(await dispatch('buildFilterParams')),
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
        },
      })

      commit('SET_RESULTS', data?.results || [])
      commit('SET_SUMMARY', data?.summary || null)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data?.rowCount,
        rowsInCurrentPage: data?.results?.length || 0,
      })
    },

    /**
     * Baixa a planilha do relatório. Sem paginação: o servidor devolve tudo que o filtro alcança.
     */
    async generateReport({ commit, dispatch }) {
      const { data } = await axios.get('/api/reports/installment-sales/download', {
        params: await dispatch('buildFilterParams'),
        responseType: 'blob',
      })

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      commit('SET_REPORT_DATA', window.URL.createObjectURL(blob))
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('CLEAN_FILTERS')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
